import DefaultLayout from "@/layouts/DefaultLayout";
import KServiceForm from "kinnect-front/KService/KServiceForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { Service } from "kinnect-models";

export default {
	name: "ServicePage",

	metaInfo() {
		const title = this.editing
			? "Services - Edit Service"
			: "Services - Add a Service";

		return { title };
	},

	props: { idService: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "services",
		deleteDialogOpen: false,
		service: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idService );
		},

		genDeleteDialog() {
			if ( this.editing && this.service && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete service" )}
					onConfirm={() => this.service.delete()}
					redirect={[ "back", { name: "services" } ]}
					title="Delete Service"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete this service?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Service",
					tooltip: "Delete this service"
				};
			}
		}
	},

	methods: {
		async fetchService() {
			if ( this.editing ) {
				this.service = await Service.findPageModel( this.idService );
			}
		},

		async fetch() {
			await this.fetchService();
		}
	},

	render() {
		return <DefaultLayout maxWidth="600px">
			<KServiceForm
				loading={this.$wait.is( "find service" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				service={this.service}
			></KServiceForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
